import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import App from './App';

const router = createBrowserRouter(
  [
    {
      element: <App />,
      path: '*',
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

export default function AppRouter() {
  return (
    <RouterProvider
      future={{ v7_startTransition: true }}
      router={router}
    />
  );
}
